export default document.addEventListener('DOMContentLoaded', () => {
  // Header nav behaviour
  const headerMenuButton = document.querySelector('.js-header-menu-button')

  if (headerMenuButton) {
    headerMenuButton.addEventListener('click', () => {
      const isExpanded = headerMenuButton.getAttribute('aria-expanded')

      headerMenuButton.setAttribute(
        'aria-expanded',
        isExpanded === 'true' ? 'false' : true
      )
    })
  }
})
